import { render, staticRenderFns } from "./GoodsAndServices.vue?vue&type=template&id=5eb6c981"
import script from "./GoodsAndServices.vue?vue&type=script&lang=js"
export * from "./GoodsAndServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports